import { type Value } from '@discover-use-router-state';
import DEFAULT_FAVOURITE from '@discover-data/stores/restaurant/model/favourite/default';

export default function getValidFavourite(routerValues: Value[]): boolean {
  if (routerValues.length === 0) {
    return DEFAULT_FAVOURITE;
  }

  const value = routerValues[0];

  if (value === undefined || value === null) {
    return DEFAULT_FAVOURITE;
  }

  if (value === 'true' || value === 'false') {
    return value === 'true';
  }

  return DEFAULT_FAVOURITE;
}
